import { Map, List } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

const identity = (x) => x;

export class LoadingStore extends BaseStore {

    getLoadingForType(type) {
        return this.state.get(type, new Map());
    }

    setLoadingForType(type, loading) {
        this.setState(this.state.set(type, loading));
    }

    isLoading(...types) {
        if (types.length) {
            const typesList = new List(types);
            return !!typesList.find((type) => this.getLoadingForType(type).find(identity));
        }
        return !!this.state.flatten().find(identity);
    }

    handleLoadStarted({ type, id }) {
        const loading = this.getLoadingForType(type).set(id, true);
        this.setLoadingForType(type, loading);
    }

    handleLoadStopped({ type, id }) {
        const loading = this.getLoadingForType(type).delete(id);
        this.setLoadingForType(type, loading);
    }

    handleLoadersStopped() {
        this.setState(new Map());
    }

    getActionHandlers () {
        return {
            [ActionTypes.LOADING_STARTED]: this.handleLoadStarted,
            [ActionTypes.LOADING_COMPLETED]: this.handleLoadStopped,
            [ActionTypes.LOADING_FAILED]: this.handleLoadStopped,
            [ActionTypes.LOADING_STOPPED]: this.handleLoadersStopped
        };
    }
}

const instance = new LoadingStore();

export default instance;
